import { useHistory } from 'react-router-dom';
import { loadTossPayments } from '@tosspayments/tosspayments-sdk';

import FetchModule from '../Network/FetchModule';
import { useLanguage } from '../../../Context/LanguageContext';

// Toss BrandPay v2 카드 등록 트리거 훅 //
// 기존 페이플 가입자가 이 경로로 카드 변경하면 백엔드가 customer_uid 를 paypal- → toss- 로 교체 (점진적 이관)
//
// 진행 흐름:
//  1. GET billing/toss/info → { userId, customerKey, token } 응답 (Bearer 토큰만, body 없음)
//  2. loadTossPayments(v2) + tossPayments.brandpay({ customerKey, redirectUrl }) 인스턴스 생성
//  3. brandpay.addPaymentMethod() 호출 → 토스 SDK 모달
//  4. resolve 시 POST billing/toss/registration/save { userId, customerKey, token } → 백엔드 등록 확정
//  5. 각 단계 분기에서 alert + onSuccess 콜백 + history.push(성공/실패 경로 — caller 가 전달)
function useTossCardRegister() {
  const history = useHistory();
  const { t } = useLanguage();

  // 카드 등록 실행 — { onSuccess, successPath, failurePath } //
  function registerCard({ onSuccess, successPath, failurePath } = {}) {

    const fetchModule = new FetchModule();
    (
      async () => {
        // Step 1: 토스 카드 등록 부트스트랩 정보 조회 //
        const responseData = await fetchModule.getDataVersion2('billing/toss/info', 'GET');

        if (responseData.status !== 200) {
          alert(responseData.error);
          if (failurePath) history.push(failurePath);
          return;
        }

        const storeId = responseData.data.storeId;
        const customerKey = responseData.data.customerKey;

        // Step 2~3: 토스 SDK 로드 + BrandPay 카드 등록 //
        try {
          const tossPayments = await loadTossPayments(process.env.REACT_APP_TOSS_CLIENT_KEY);

          const brandpay = tossPayments.brandpay({
            customerKey: customerKey,
            redirectUrl: fetchModule.baseURL + fetchModule.apiVersion2 + 'billing/toss/auth'
          });
          brandpay.addPaymentMethod()
            .then(() => {

              // Step 4: 백엔드 등록 확정 //
              const requestData = {
                storeId: storeId,
                customerKey: customerKey
              };

              const fm = new FetchModule();
              (
                async () => {
                  const saveRes = await fm.postDataVersion2('billing/toss/registration', 'POST', requestData);

                  if (saveRes.status === 200) {
                    alert(t('myStoreSetting.billingInfo.cardRegistered'));
                    if (onSuccess) onSuccess();
                    if (successPath) history.push(successPath);
                  }
                  else if (saveRes.status === 401) {
                    if (failurePath) history.push(failurePath);
                  }
                  else {
                    alert(t('myStoreSetting.billingInfo.cardRegisterFailed'));
                    if (failurePath) history.push(failurePath);
                  }
                }
              )();
            })
            .catch((e) => {
              alert(t('myStoreSetting.billingInfo.cardRegisterFailed'));
              if (failurePath) history.push(failurePath);
            });
        }
        catch (e) {
          alert(t('myStoreSetting.billingInfo.cardRegisterSdkError'));
          if (failurePath) history.push(failurePath);
        }
      }
    )();
  }

  return registerCard;
}

export default useTossCardRegister;
